export const gradients = [
    ['white'],
    ['red', 'yellow', 'blue', 'violet'],
    ['#e96443', '#904e95'],
    ['#E55D87', '#5FC3E4'],
    ['#00416A', '#799F0C', '#FFE000'],
    ['#1a2a6c', '#b21f1f', '#fdbb2d'],
    ['#fdeff9', '#ec38bc', '#7303c0', '#03001e'],
    ['#dd1818', '#333333'],
    ['#40e0d0', '#ff8c00', '#ff0080'],
    ['#3e5151', '#decba4'],
    ['#11998e', '#38ef7d'],
    ['#22c1c3', '#fdbb2d'],
    ['#b24592', '#f15f79'],
    ['#f1f2b5', '#135058'],
    ['#ff0084', '#33001b'],
    ['#833ab4', '#fd1d1d', '#fcb045'],
    ['#d38312', '#a83279'],
    ['#556270', '#ff6b6b'],
    ['#c21500', '#ffc500'],
    ['#134e5e', '#71b280'],
    ['#ffe000', '#799f0c'],
    ['#9796f0', '#fbc7d4'],
    ['#3EECAC', '#EE74E1'],
    ['#FA8BFF', '#2BD2FF', '#2BFF88'],
    ['#FF3CAC', '#784BA0', '#2B86C5'],
    ['#30cfd0', '#330867'],
    ['#eea2a2', '#bbc1bf', '#57c6e1', '#b49fda', '#7ac5d8'],
    ['#3d3393', '#2b76b9', '#2cacd1', '#35eb93'],
    ['#ff00ff', '#00fff0', '#f9ff00', '#ff4d00'],
    ['#120458', '#3b0f70', '#8c2981', '#de4968', '#fe9f6d'],
    ['#00f5d4', '#00bbf9', '#9b5de5', '#f15bb5', '#fee440'],
    ['#ff206e', '#fbff12', '#41ead4', '#ffffff', '#011627'],
    ['#ff5f6d', '#ffc371', '#47cacc', '#845ec2'],
    ['#7f00ff', '#e100ff', '#00dbde', '#fc00ff'],
    ['#39ff14', '#00a1ff', '#ff00a8', '#ffe600', '#0a0a0a'],
    ['#ff9a00', '#ff165d', '#6a00f4', '#00d4ff'],
    ['#f72585', '#7209b7', '#3a0ca3', '#4361ee', '#4cc9f0'],
    ['#ffef00', '#ff006e', '#8338ec', '#3a86ff', '#06d6a0'],
    ['#ff6a00', '#ffb703', '#ffd166'],
    ['#00c6ff', '#0072ff', '#3a0ca3'],
    ['#ff4ecd', '#ff6b6b', '#ff9f1c'],
    ['#00f260', '#0575e6', '#7b2ff7'],
    ['#08f7fe', '#fe53bb', '#f5d300'],
    ['#00f5ff', '#9d4edd', '#ff4d6d', '#ffd60a'],
    ['#06ffa5', '#00bbf9', '#4361ee', '#b5179e'],
    ['#ff7b00', '#ff006e', '#8338ec', '#3a86ff'],
    ['#00ff87', '#60efff', '#0061ff', '#8f00ff'],
    ['#f72585', '#ffba08', '#3a86ff', '#06d6a0'],
    ['#ff0054', '#00e5ff', '#ffe600'],
    ['#00f0b5', '#ff3d00', '#6f00ff'],
    ['#000000', '#00ffd0', '#ff2d95'],
    ['#000000', '#ffe600', '#00a6ff'],
    ['#ff1744', '#39ff14', '#2979ff'],
    ['#000000', '#ff6d00', '#7c4dff'],
]
